import { useCallback, useEffect } from 'preact/hooks';
import { debounce } from '../utils/utils';

const DELAY_RESIZE = 150;

export const useResize = (updateSize: () => void, dependencies: Array<any> = []): void => {
  const updateSizeCallback = useCallback(updateSize, [...dependencies, updateSize]);
  useEffect(() => {
    updateSizeCallback();
  }, [updateSizeCallback]);
  useEffect(() => {
    const wrapper = debounce(updateSizeCallback, DELAY_RESIZE);
    window.addEventListener('resize', wrapper);
    return (): void => {
      window.removeEventListener('resize', wrapper);
    };
  }, [updateSizeCallback]);
};
